// Generated by CoffeeScript 1.12.1
(function() {
  var Cache, Dns, Helper, Srv, _, superagent;

  superagent = require('superagent');

  _ = {
    each: require('lodash/each'),
    map: require('lodash/map')
  };

  Helper = require('./helper');

  Srv = require('./srv');

  Cache = require('./cache');

  Dns = (function() {
    function Dns() {}

    Dns.DNS_HTTP_SERVER = 'https://dns.google.com';

    Dns.resolveSrv = function(hostname, callback) {
      var request;
      if (Cache.has('SRV', hostname)) {
        return callback(null, Cache.get('SRV', hostname));
      }
      request = superagent.get(Helper.url({
        baseUrl: Dns.DNS_HTTP_SERVER,
        name: hostname,
        type: 'SRV'
      })).set('Accept', 'application/json');
      if (typeof window === "undefined" || window === null) {
        request = request.buffer(true);
      }
      request.end(function(error, result) {
        if (error != null) {
          return callback(error);
        }
        Srv.parseResult(result, (function(_this) {
          return function(error, records) {
            if (error != null) {
              return callback(error);
            }
            Dns._cacheRecords('SRV', hostname, records);
            return callback(null, _.map(records, 'address'));
          };
        })(this));
      });
    };

    Dns._cacheRecords = function(type, hostname, records) {
      return _.each(records, function(record) {
        return Cache.set(type, hostname, record.address, record.ttl);
      });
    };

    return Dns;

  })();

  module.exports = Dns;

}).call(this);



//////////////////
// WEBPACK FOOTER
// ./~/http-dns/dist/dns.js
// module id = 66
// module chunks = 0